import { Button } from "@/components/ui/button";
import {
    Trash,
    Pause,
    Receipt,
    UserCircle,
    Archive,
    Barcode,
    Calculator,
    ArrowUUpLeft,
} from "@phosphor-icons/react";

export default function PosActionBar({
    onClear,
    onPark,
    onSubmit,
    onOpenCustomer,
    onOpenParked,
    onOpenScanner,
    onOpenNumpad,
    onOpenReturn,
    submitting,
    canSubmit,
    cartEmpty,
    parkedCount,
    hasCustomer,
    numpadOpen,
}) {
    return (
        <div className="bg-white border-2 border-[#0A0A0A] flex flex-wrap gap-2 p-2 items-center">
            {/* Return button — first/leftmost */}
            <Button
                onClick={onOpenReturn}
                data-testid="pos-return-btn"
                className="rounded-none h-14 px-5 min-w-[130px] bg-[#8B2530] hover:bg-[#6B1A24] text-white font-black text-sm tracking-wider"
            >
                <ArrowUUpLeft size={18} weight="bold" className="mr-2" />
                ΕΠΙΣΤΡΟΦΗ
            </Button>
            {/* Primary actions */}
            <Button
                onClick={onClear}
                data-testid="pos-clear-btn"
                className="rounded-none h-14 px-5 min-w-[130px] bg-[#34C759] hover:bg-[#2BAE48] text-white font-black text-sm tracking-wider"
            >
                <Trash size={18} weight="bold" className="mr-2" />
                ΕΚΚΑΘΑΡΙΣΗ
            </Button>
            <Button
                onClick={onPark}
                disabled={cartEmpty}
                data-testid="pos-park-btn"
                className="rounded-none h-14 px-5 min-w-[130px] bg-[#FF9500] hover:bg-[#E08600] text-white font-black text-sm tracking-wider disabled:bg-[#B5B7BC] disabled:text-white"
            >
                <Pause size={18} weight="fill" className="mr-2" />
                ΑΝΑΣΤΟΛΗ
            </Button>
            <Button
                onClick={onSubmit}
                disabled={!canSubmit || submitting}
                data-testid="pos-submit-btn"
                className="rounded-none h-14 px-6 min-w-[200px] bg-[#FF3B30] hover:bg-[#D72D24] text-white font-black text-sm tracking-wider disabled:bg-[#B5B7BC] disabled:text-white"
            >
                <Receipt size={18} weight="bold" className="mr-2" />
                {submitting ? "ΚΑΤΑΧΩΡΗΣΗ..." : "ΟΛΟΚΛΗΡΩΣΗ ΠΑΡΑΓΓΕΛΙΑΣ"}
            </Button>

            <div className="ml-auto flex gap-2">
                <Button
                    onClick={onOpenCustomer}
                    data-testid="pos-circle-customer"
                    className="rounded-none h-14 px-4 min-w-[120px] bg-white border-2 border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white font-black text-sm tracking-wider"
                >
                    <UserCircle size={18} weight="bold" className="mr-2" />
                    {hasCustomer ? "ΑΛΛΑΓΗ" : "ΠΕΛΑΤΗΣ"}
                </Button>
                <Button
                    onClick={onOpenScanner}
                    data-testid="pos-circle-scan"
                    className="rounded-none h-14 px-4 min-w-[120px] bg-white border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-black text-sm tracking-wider"
                >
                    <Barcode size={18} weight="bold" className="mr-2" />
                    ΣΑΡΩΣΗ
                </Button>
                <Button
                    onClick={onOpenNumpad}
                    data-testid="pos-circle-numpad"
                    className="rounded-none h-14 px-4 min-w-[120px] bg-white border-2 border-[#5856D6] text-[#5856D6] hover:bg-[#5856D6] hover:text-white font-black text-sm tracking-wider"
                >
                    <Calculator size={18} weight="bold" className="mr-2" />
                    NUMPAD
                </Button>
                <Button
                    onClick={onOpenParked}
                    data-testid="pos-circle-parked"
                    className="relative rounded-none h-14 px-4 min-w-[120px] bg-white border-2 border-[#FF9500] text-[#FF9500] hover:bg-[#FF9500] hover:text-white font-black text-sm tracking-wider"
                >
                    <Archive size={18} weight="bold" className="mr-2" />
                    ΣΕ ΑΝΑΣΤΟΛΗ
                    {parkedCount > 0 && (
                        <span className="absolute -top-2 -right-2 bg-[#FF3B30] text-white text-[10px] font-black w-5 h-5 flex items-center justify-center rounded-full border-2 border-white">
                            {parkedCount}
                        </span>
                    )}
                </Button>
            </div>
        </div>
    );
}
